module.exports = __webpack_public_path__ + "img/settings.2c42b955.png";